import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import StatisticsCards from '@/views/dashboard/_components/statistics-cards/statistics-cards.vue'
import type { StatisticsCardItem } from '@/views/dashboard/_components/statistics-cards/types'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import type { BootOptimizeStatCardKey } from './boot-optimize-statistics-cards.types'


export default /*#__PURE__*/_defineComponent({
  __name: 'statistics-cards',
  props: {
    totalBootItems: {},
    trustedBootItems: {}
  },
  emits: ["statClick"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { t, locale } = useI18n()
const statisticsItems = computed((): StatisticsCardItem[] => {
  void locale.value
  const total = props.totalBootItems ?? 0
  const trusted = props.trustedBootItems ?? 0
  return [
    {
      label: t('bootOptimize.statTotalBootItems'),
      value: total,
      clickable: total > 0,
      events: {
        click: () => {
          if (total <= 0) return
          emit('statClick', 'totalBootItems')
        }
      }
    },
    {
      label: t('bootOptimize.statTrustedBootItems'),
      value: trusted,
      clickable: trusted > 0,
      events: {
        click: () => {
          if (trusted <= 0) return
          emit('statClick', 'trustedBootItems')
        }
      }
    }
  ]
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(StatisticsCards, { items: statisticsItems.value }, null, 8, ["items"]))
}
}

})